module.exports = "/static/media/avatar.9a7806dd.svg";